
import { Navigate } from "react-router-dom";
import { getAuthToken } from "../utils/token";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = getAuthToken();

  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;
  const role = user?.user?.role;

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;

